export default __webpack_public_path__ + "static/media/d_planning.5bfa7db7.png";